class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
    document.addEventListener("keydown", this.handleKeyDown.bind(this));
  }

  bindEvents() {
    this.bindOpenButton();
    this.querySelectorAll("[data-close-drawer]").forEach((button) =>
      button.addEventListener("click", this.closeDrawer.bind(this))
    );
    this.dialogEvents();
  }

  bindOpenButton() {
    const openBtn = document.querySelector("[data-cart-drawer-btn]");
    if (openBtn) {
      ["click", "touchstart"].forEach((eventType) =>
        openBtn.addEventListener(eventType, this.openDrawer.bind(this))
      );
    }
  }

  openDrawer(event) {
    event.preventDefault();

    document.body.classList.add("drawer-open", "cart-drawer-blur-active", "overflow-hidden");

    this.classList.add("open");

    // Reset backdrop filter in case left behind from a previous close
    document.querySelectorAll(".cart-drawer-blur, .cart-drawer.blur").forEach((el) => {
      el.style.backdropFilter = "";
      el.style.webkitBackdropFilter = "";
      el.style.opacity = "";
      el.style.pointerEvents = "";
    });

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        this.querySelector(".drawer-inner-card").innerHTML = this.getSectionInnerHTML(html);
        this.querySelectorAll("[data-close-drawer]").forEach((button) =>
          button.addEventListener("click", this.closeDrawer.bind(this))
        );
        this.dialogEvents();

        setTimeout(() => {
          if (event.target) {
            focusElement = event.target;
            trapFocusElements(this);
          }
        }, 300);

        setTimeout(() => {
          fetch("/cart.js")
            .then((response) => response.json())
            .then((data) => {
              shippingBarProgress(data.total_price);
            });
        }, 300);
      });
  }

closeDrawer(event) {
  this.classList.remove("open");
  void this.offsetWidth; 
  document.body.classList.remove('drawer-open', 'overflow-hidden', 'no-scroll', 'cart-drawer-blur', 'cart-drawer-blur-active');

  // Start blur fadeout cleanup
  setTimeout(() => {
    document.body.classList.remove("cart-drawer-blur-active");

    document.querySelectorAll(".cart-drawer-blur, .cart-drawer.blur").forEach((el) => {
      el.classList.add("force-hide");

      // Allow transition to complete before full cleanup
      setTimeout(() => {
        el.classList.remove("force-hide");
        el.removeAttribute("style");
      }, 200); // Match your CSS transition time
    });
  }, 200);

  if (typeof focusElement !== "undefined" && focusElement) {
    focusElement.focus();
    focusElement = "";
  }

  removeTrapFocus();
}

  renderContents(parsedState) {
    if (!parsedState) return;

    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      if (container) {
        const html = parsedState.sections[section.id];
        const newInner = this.getSectionInnerHTML(html, section.selector);
        container.querySelector(section.selector).innerHTML = newInner;

        const totalCount = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector("#cart-drawer-body")
          ?.getAttribute("data-cart-count");

        const countEl = document.querySelector("[data-item-count]");
        if (countEl) {
          countEl.classList.toggle("hidden", totalCount == 0);
          countEl.textContent = totalCount < 100 ? totalCount : "99+";
        }

        this.dialogEvents();
        this.querySelectorAll("[data-close-drawer]").forEach((button) =>
          button.addEventListener("click", this.closeDrawer.bind(this))
        );
        this.bindOpenButton();
      }
    });
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: ".drawer-inner-card"
      }
    ];
  }

  getSectionInnerHTML(html, selector = ".drawer-inner-card") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  handleKeyDown(event) {
    if (event.key === "Escape") {
      this.closeDrawer(event);
    }
  }

  dialogEvents() {
    let focusElementDrawer = "";
    this.querySelectorAll(".cart-modal-button").forEach((button) => {
      button.addEventListener("click", (e) => {
        const modal = button.dataset.modal;
        const dialog = this.querySelector(`cart-dialog#${modal}`);
        if (dialog) {
          dialog.style.display = "block";
          setTimeout(() => {
            dialog.classList.add("active");
            focusElementDrawer = button;
            trapFocusElements(dialog);
          }, 200);
        }
      });
    });

    this.querySelectorAll(".cart-dialog-close").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const dialog = button.closest("cart-dialog");
        dialog.classList.remove("active");
        trapFocusElements(this);
        setTimeout(() => {
          dialog.style.display = "none";
          if (focusElementDrawer) focusElementDrawer.focus();
          focusElementDrawer = "";
        }, 200);
      });
    });
  }
}

customElements.define("cart-drawer", CartDrawer);